export const enumDemandeFormationArchive = {
    NON_ARCHIVED : 0,
    ARCHIVED : 1,
    ALL : 2
}